module.exports = __webpack_public_path__ + "static/media/sparkles.e23f63d9.webp";